import './styles/lora.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home   from './pages/Home';
import WhatsAppIcon from './components/WhatsAppIcon';

const WA_URL =
  "https://wa.me/5511986304696?text=Ol%C3%A1!%20Vim%20pelo%20site%20da%20l'ora%20e%20gostaria%20de%20uma%20proposta.";

export default function App() {
  return (
    <>
      <Navbar />
      <Home />
      <Footer />

      {/* Sticky WhatsApp CTA — visible only on mobile via CSS */}
      <a
        className="btn sticky"
        href={WA_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Fale com a l’ora no WhatsApp"
      >
        <WhatsAppIcon />
        <span>
          Fale com a l’ora<span className="arrow" aria-hidden="true">→</span>
        </span>
      </a>
    </>
  );
}
